import { Dialog, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { Address, GeoLocation } from "../../services/swagger";
import FormTemplate from "../templates/FormTemplate";
import FormInput from "./FormInput";
import { Delete } from "@mui/icons-material";

interface AddressDialogProps {
  address?: Address;
  open: boolean;
  onClose: () => any;
  onSave: (address: Address) => any;
  onDelete: () => any;
}

export default function AddressDialog(props: AddressDialogProps) {
  const { address } = props;
  const { t } = useTranslation("Address");
  const [name, setName] = useState("");
  const [line1, setLine1] = useState("");
  const [line2, setLine2] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [geo, setGeo] = useState<GeoLocation>();

  useEffect(() => {
    if (!props.open) return;
    if (!address) return;
    setName(address.name || "");
    setLine1(address.line1 || "");
    setLine2(address.line2 || "");
    setCity(address.city || "");
    setState(address.state || "");
    setCountry(address.country || "");
    setPostalCode(address.postalCode || "");
    setGeo(address.geo);
  }, [props.open]);

  const handleSubmit = () => {
    props.onSave({
      city,
      country,
      line1,
      line2,
      name,
      postalCode,
      state,
      geo,
    });
  };

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <FormTemplate
        title={t("Address")}
        onSubmit={handleSubmit}
        onCancel={props.onClose}
        options={
          props.address
            ? [
                {
                  label: t("Delete"),
                  onClick: props.onDelete,
                  icon: <Delete color="error" />,
                },
              ]
            : undefined
        }
        noForm
        confirm
      >
        <Stack spacing={1}>
          <FormInput
            field="name"
            label={t("Name")}
            type="string"
            value={name}
            onChange={(v) => setName(v as string)}
          />
          <FormInput
            field="line1"
            label={t("Line1")}
            type="string"
            value={line1}
            onChange={(v) => setLine1(v as string)}
          />
          <FormInput
            field="line2"
            label={t("Line2")}
            type="string"
            value={line2}
            onChange={(v) => setLine2(v as string)}
          />
          <FormInput
            field="city"
            label={t("City")}
            type="string"
            value={city}
            onChange={(v) => setCity(v as string)}
          />
          <FormInput
            field="state"
            label={t("State")}
            type="string"
            value={state}
            onChange={(v) => setState(v as string)}
          />
          <FormInput
            field="country"
            label={t("Country")}
            type="string"
            value={country}
            onChange={(v) => setCountry(v as string)}
          />
          <FormInput
            field="postalCode"
            label={t("PostalCode")}
            type="string"
            value={postalCode}
            onChange={(v) => setPostalCode(v as string)}
          />
        </Stack>
      </FormTemplate>
    </Dialog>
  );
}
